import AppointmentConfirmationModal from "./AppointmentConfirmationModal";

export default AppointmentConfirmationModal;

export * from "./AppointmentConfirmationModal";
